import { render, staticRenderFns } from "./biography-correction-show.vue?vue&type=template&id=1f55586b&"
import script from "./biography-correction-show.vue?vue&type=script&lang=js&"
export * from "./biography-correction-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports